import { useSelector } from "react-redux";
import { InputFormsTitle, PreferredICCard } from "../../components";
import { useInputPageHook } from "../../hooks";
import {
  InputFormButtonWrapperStyled,
  InputFormContinueButtonStyled,
  PreferredICLogoContainerStyled,
} from "../../styles/inputForms.styled";
import usePreferredICForm from "./usePreferredICForm";

const PreferredICForm = ({ setCurrent, current }) => {
  const {
    termInputPage4 = "<h1>Select Preferred Insurance Company</h1>",
    termInputsCompany = {},
  } = useInputPageHook();
  const allProductNames = [];
  const { isLoading } = useSelector(state => state?.frontendBoot);

  Object?.keys(termInputsCompany)?.forEach(insuranceCompanyName => {
    const products = termInputsCompany[insuranceCompanyName];
    Object?.keys(products)?.forEach(productName => {
      allProductNames.push({ productName, insuranceCompanyName });
    });
  });

  const { onSubmit, handleSubmit, onSkip, setValue } = usePreferredICForm(
    current,
    setCurrent,
  );
  const { preferred_ic, preferred_product } = useSelector(
    state => state?.inputForm?.data,
  );
  return (
    <>
      {isLoading ? (
        <></>
      ) : (
        <InputFormsTitle
          title={termInputPage4}
          current={current}
          onSubmit={handleSubmit(preferred_ic ? onSubmit : onSkip)}
        >
          <PreferredICLogoContainerStyled>
            {allProductNames?.map(product => {
              return (
                <PreferredICCard
                  keys={JSON.stringify(product)}
                  productName={product?.productName}
                  insuranceCompanyName={product?.insuranceCompanyName}
                  setValue={setValue}
                  preferredProduct={preferred_product}
                />
              );
            })}
          </PreferredICLogoContainerStyled>
          <InputFormButtonWrapperStyled>
            {preferred_ic ? (
              <InputFormContinueButtonStyled type="submit">
                Continue
              </InputFormContinueButtonStyled>
            ) : (
              <InputFormContinueButtonStyled type="submit">
                Skip
              </InputFormContinueButtonStyled>
            )}
          </InputFormButtonWrapperStyled>
        </InputFormsTitle>
      )}
    </>
  );
};

export default PreferredICForm;
